<div>
<h3 class="text-3xl font-semibold text-orange-gradient mb-2">{{title()}}</h3>
<p class="font-medium text-sm">{{description()}}</p>
</div>
